import { gql } from '@apollo/client';
import React from 'react';
import SocialPinterestIcon from '@moda/icons/social-pinterest-16';
import { PinterestShareLinkFragment, PinterestShareVariantFragment } from '../../generated/types';
import { ShareLink, WINDOW_VARIABLES } from './ShareLink';

interface Props {
  variant: PinterestShareLinkFragment;
  activeVariant: PinterestShareVariantFragment;
}

export const PINTEREST_SHARE_VARIANT_FRAGMENT = gql`
  fragment PinterestShareVariantFragment on VariantData {
    primaryImageUrls: primary_image_urls {
      large
    }
  }
`;

export const PINTEREST_SHARE_LINK_FRAGMENT = gql`
  fragment PinterestShareLinkFragment on Variant {
    isBoutique: is_boutique
    name
    designerName: designer_name

    masterVariant: master_variants_data {
      ...PinterestShareVariantFragment
    }
    otherVariants: other_variants_data {
      ...PinterestShareVariantFragment
    }
  }

  ${PINTEREST_SHARE_VARIANT_FRAGMENT}
`;

export const pinterestShareLink = 'https://pinterest.com/pin/create/button/?url=';

const shareOnPinterest = (variant: PinterestShareLinkFragment, image: string) => {
  const url = location.origin + location.pathname + '?utm_source=pinterest&utm_medium=share';
  const availability = variant.isBoutique ? ' Now Available ' : ' for Preorder ';
  const description = `${variant.name} by ${
    variant.designerName.toUpperCase() + availability
  }on Moda Operandi`;

  const pinterestLink = `${
    pinterestShareLink + encodeURIComponent(url)
  }&media=${image}&description=${encodeURIComponent(description)}`;
  window.open(pinterestLink, '_blank', WINDOW_VARIABLES);
};

export const PinterestShareLink: React.FC<Props> = ({ variant, activeVariant }) => {
  return (
    <ShareLink
      aria-label="Share with Pinterest"
      handleClick={() => shareOnPinterest(variant, activeVariant.primaryImageUrls.large || '')}
      data-testid="pinterest-share-link"
    >
      <SocialPinterestIcon />
    </ShareLink>
  );
};
